module.exports = function getReleaseStage(host = '') {
  switch (true) {
    case host.includes('-l.zubie.com'):
      return 'development';
    case host.includes('-qa.zubie.com'):
      return 'qa';
    case host.includes('-beta.zubie.com'):
      return 'beta';
    default:
      return 'production';
  }
};
